import { FormElementComponent } from 'components/common/form/element/FormElementComponent';
import useTemplateFormTools from 'components/common/form/hooks/useTemplateFormTools';
import { customTabProps, ITabProps } from 'components/common/form/layout/tab';
import { FormLayoutComposer, IFormLayoutProps } from 'components/common/form/renderer/FormLayoutComposer';
import { Stack } from '@mui/material';
import { FormTabContent } from 'components/common/form/layout/tab/FormTabContent';
import { useQueryClient } from '@tanstack/react-query';
import { ActSubmit } from 'components/common/form/act';

export default function PortalPageForm(props: IFormLayoutProps) {
    const codeTab = <CodeTab {...customTabProps(props, 'code')} />;
    const queryClient = useQueryClient();
    props.hookForm.form.formAct.overrideAct(
        'submit',
        class extends ActSubmit {
            exec = async (data: any) => {
                return super.exec(data).then((response) => {
                    const portalPageId = props.elementProps.urlParams[props.elementProps.pk ?? '0'] ?? 0;
                    queryClient.invalidateQueries({ queryKey: [`assets-tree-${portalPageId}`] });
                    return response;
                });
            };
        },
    );

    const customProps = {
        ...props,
        customTabs: { code: codeTab },
    };

    return <FormLayoutComposer props={customProps} />;
}

function CodeTab(tabProps: ITabProps) {
    const { getElementProps, hookForm } = useTemplateFormTools(tabProps);

    return (
        <FormTabContent {...tabProps}>
            <Stack
                alignItems="center"
                className={
                    'default-components form-components-indent scroll-content-container scroll-content-container--form'
                }
                sx={{
                    overflow: 'none',
                    flexGrow: 1,
                    width: '100%',
                    height: '100%',
                    pb: 3,
                    px: (theme) => theme.size.pxValue(theme.size.containerIndentX),
                }}
            >
                <FormElementComponent {...getElementProps('html_code')} />
                <FormElementComponent {...getElementProps('javascript_code_history')} />
                <FormElementComponent {...getElementProps('javascript_code')} />
            </Stack>
        </FormTabContent>
    );
}
